import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useEquipmentStyles = makeStyles((theme: Theme) =>
  createStyles({
    hazardIcon: {
      backgroundColor: 'transparent',
      width: '60px',
      height: '60px',
      marginRight: '10px',
    },
    protectiveMeasuresContainer: {
      marginTop: '10px',
      marginBottom: '20px',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '80%',
      flexShrink: 0,
    },
    serviceSection: {
      marginTop: '15px',
      marginBottom: '15px',
      paddingTop: '10px',
      borderTop: '1px solid #e0e0e0',
    },
    serviceSectionTitle: {
      marginBottom: '8px',
    },
    serviceRow: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '4px',
    },
    detailTable: {
      marginTop: '15px',
      '& td': {
        padding: '8px 16px',
      },
      '& td:first-child': {
        fontWeight: 'bold',
        color: '#0000008a',
      },
    },
  })
);
